// extracted by mini-css-extract-plugin
export var contactFormSection = "dl_zR";
export var contactFormSection__infoBg = "dl_zT";
export var contactFormSection__title = "dl_zS";